import STATIC_URLS from '../../../statics/manifest';

const BASE_URL = process.env.STATIC_URL_BASE ?? '';

export default function staticUrl(key) {
  if (!(key in STATIC_URLS)) {
    throw new Error(`${key} does not locate an available static file. Check statics/manifest.json`);
  }
  return BASE_URL + STATIC_URLS[key];
}
